import axiosInstance from "../api";
import { notification } from "antd";



export const createMasterTag = async (tagData) => {
  try {
    const formData = new FormData();
    formData.append("name", tagData.name);
    if(tagData.description){
        formData.append("description", tagData.description);
    }

    const response = await axiosInstance.post("/tags/add_master", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Creation Error",
        description:
          response.data.message ||
          "An error occurred while creating the master Tag",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Creation Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error creating Master tag"
    );
  }
};

export const updateMasterTag = async (update_master_tag_data) => {
  try {
    const formData = new FormData();
    if (update_master_tag_data.name) {
      formData.append("name", update_master_tag_data.name);
    }
    if (update_master_tag_data.description) {
      formData.append("description", update_master_tag_data.description);
    } else {
        formData.append("description", '');
    }
    if (update_master_tag_data.id) {
      formData.append("row_id", update_master_tag_data.id);
    }

    const response = await axiosInstance.put(
      `/tags/update_master`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description:
          response.data.message ||
          "An error occurred while updating Master Tag.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error Update Master Tags"
    );
  }
};

export const activateDeactivateMasterTags = async (id, active) => {
  try {
    const payload = { id : id, active: active}
    const response = await axiosInstance.post(`/tags/activate_deactivate`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};


export const getAllMasterTags = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/tags/get_all_master?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Master Tags",
      description:
        response?.data?.message || "Failed to fetch Master Tags",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Master Tags",
      description:
        error.response?.data?.message || "Failed to fetch Master Tags",
      duration: 3,
    });
    throw new Error("Error fetching Master Tags");
  }
};


export const getActiveMasterTag = async (page, name, limit=100) => {
  try {
    console.log(page, limit)
    const params = {
      skip: page * limit,
      limit: limit,
      search: name || "",
    };

    const response = await axiosInstance.get(
      `/tags/get_active_tag`, { params }
    );
    if (response?.data?.status_code === 200) {
      return response?.data?.data.master_tags.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }
    notification.error({
      message: "Error Fetching master tags",
      description:
        response?.data?.message || "Failed to fetch master tags list.",
      duration: 3,
    });
    return []
  } catch (error) {
    notification.error({
      message: "Error Fetching master tag",
      description:
        error.response?.data?.message || "Failed to fetch master active tag list.",
      duration: 3,
    });
    throw new Error("Error fetching master tag");
  }
};

export const getUserTags = async (user_id) => {
  try {
    const params = {"user_id": user_id};

    const response = await axiosInstance.get(
      `/tags/users_tag`, { params }
    );
    if (response?.data?.status_code === 200) {
      return response?.data;
    }
    notification.error({
      message: "Error Fetching user tags",
      description:
        response?.data?.message || "Failed to fetch user tags list.",
      duration: 3,
    });
    return []
  } catch (error) {
    notification.error({
      message: "Error Fetching master tag",
      description:
        error.response?.data?.message || "Failed to fetch user active tag list.",
      duration: 3,
    });
    throw new Error("Error fetching user tag");
  }
};


export const updateUserTag = async (id, data) => {
  try {
    const payload = { user_id : id, tag_ids: data}
    const response = await axiosInstance.post(`/tags/update_user_tag`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during  tag update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};

export const updateTagUsers = async (tag_id, user_ids) => {
  try {
    const payload = { user_ids : user_ids, tag_id: tag_id}
    const response = await axiosInstance.post(`/tags/update_master_tag_to_user`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during tag user update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "tag user Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
}


export const getTagUser = async ({
  tag_id,
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('tag_id', tag_id)
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/tags/list_tag_user?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Master Tags Users",
      description:
        response?.data?.message || "Failed to fetch Master Tags Users",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Master Tags Users",
      description:
        error.response?.data?.message || "Failed to fetch Master Tags Users",
      duration: 3,
    });
    throw new Error("Error fetching Master Tags Users");
  }
};

export const DelTagMappedUsers = async (user_id, tag_id) => {
  try {
    const payload = { user_id : user_id, tag_id: tag_id}
    const response = await axiosInstance.post(`/tags/del_tag_to_user`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during tag tag user delete.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "tag user delete Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
}
